import { AnalyseResponseOut, GenresResponse, ProductsResponseOut } from '../api';
import { Action } from 'redux';
import { ErrorAction } from '../index';

export const COLLECTION_CLEAR_GENRES = 'COLLECTION_CLEAR_GENRES';
export const COLLECTION_REQUEST_GENRES = 'COLLECTION_REQUEST_GENRES';
export const COLLECTION_SUCCESS_GENRES = 'COLLECTION_SUCCESS_GENRES';

export const COLLECTION_BY_GENRE_SET_GENRE = 'COLLECTION_BY_GENRE_SET_GENRE';

export const COLLECTION_BY_GENRE_PRODUCTS_REQUEST = 'COLLECTION_BY_GENRE_PRODUCTS_REQUEST';
export const COLLECTION_BY_GENRE_PRODUCTS_SUCCESS = 'COLLECTION_BY_GENRE_PRODUCTS_SUCCESS';
export const COLLECTION_BY_GENRE_PRODUCTS_FAILURE = 'COLLECTION_BY_GENRE_PRODUCTS_FAILURE';
export const COLLECTION_BY_GENRE_PRODUCTS_RESET = 'COLLECTION_BY_GENRE_PRODUCTS_RESET';

export const ANALYSE_REQUEST = 'ANALYSE_REQUEST';
export const ANALYSE_SUCCESS = 'ANALYSE_SUCCESS';
export const ANALYSE_FAILURE = 'ANALYSE_FAILURE';
export const ANALYSE_RESET_AFTER_FAILURE = 'ANALYSE_RESET_AFTER_FAILURE';

export type CollectionGenresClear = Action<typeof COLLECTION_CLEAR_GENRES>;
export type CollectionGenresRequest = Action<typeof COLLECTION_REQUEST_GENRES>;
export type CollectionGenresSuccess = {
    type: typeof COLLECTION_SUCCESS_GENRES;
    payload: GenresResponse;
};

export type CollectionByGenreSetGenre = {
    type: typeof COLLECTION_BY_GENRE_SET_GENRE;
    payload: string;
};

export type CollectionByGenreProductsRequest = Action<typeof COLLECTION_BY_GENRE_PRODUCTS_REQUEST>;
export type CollectionByGenreProductsSuccess = {
    type: typeof COLLECTION_BY_GENRE_PRODUCTS_SUCCESS;
    payload: ProductsResponseOut;
};
export type CollectionByGenreProductsFailure = ErrorAction<typeof COLLECTION_BY_GENRE_PRODUCTS_FAILURE>;
export type CollectionByGenreProductsReset = Action<typeof COLLECTION_BY_GENRE_PRODUCTS_RESET>;

export type AnalyseRequest = Action<typeof ANALYSE_REQUEST>;
export type AnalyseSuccess = {
    type: typeof ANALYSE_SUCCESS;
    payload: AnalyseResponseOut;
};
export type AnalyseFailure = ErrorAction<typeof ANALYSE_FAILURE>;
export type AnalyseReset = Action<typeof ANALYSE_RESET_AFTER_FAILURE>;

export type CollectionAction =
    | CollectionGenresClear
    | CollectionGenresRequest
    | CollectionGenresSuccess
    | CollectionByGenreSetGenre
    | CollectionByGenreProductsRequest
    | CollectionByGenreProductsSuccess
    | CollectionByGenreProductsFailure
    | CollectionByGenreProductsReset
    | AnalyseRequest
    | AnalyseSuccess
    | AnalyseFailure
    | AnalyseReset;
